export const StateChanges = {
  SET_DIRECT_RESULTS: 'SET_DIRECT_RESULTS',
  SET_TEXT_FOR_API_CALL: 'SET_TEXT_FOR_API_CALL',
  SET_DATA_FOR_SYNOPSIS: 'SET_DATA_FOR_SYNOPSIS',
  SET_VISUALIZER: 'SET_VISUALIZER',
  SET_MAX_RANGE: 'SET_MAX_RANGE',
  SET_MIN_RANGE: 'SET_MIN_RANGE',
  SET_MODE: 'SET_MODE',
  SET_DATA: 'SET_DATA',
  SET_SESSION_ID: 'SET_SESSION_ID',
  SET_FILE_TXT_RESULTS: 'SET_FILE_TXT_RESULTS',
  SET_FILE_DOC_RESULTS: 'SET_FILE_DOC_RESULTS',
  SET_SYNOPSIS_FILE_RESULTS: 'SET_SYNOPSIS_FILE_RESULTS',
  SET_SELECTED_RESULTS: 'SET_SELECTED_RESULTS',
  SET_TALMUD_RESULTS: 'SET_TALMUD_RESULTS',
  SET_MISHNA_RESULTS: 'SET_MISHNA_RESULTS',
  SET_TANAKH_RESULTS: 'SET_TANAKH_RESULTS',
  SET_FOOTNOTE_RESULTS: 'SET_FOOTNOTE_RESULTS',
  SET_VERSE_FOR_CHAPTER: 'SET_VERSE_FOR_CHAPTER',
  SET_CHAPTER_RESULTS: 'SET_CHAPTER_RESULTS',
  SET_VISUALIZER_RESULTS: 'SET_VISUALIZER_RESULTS',
  SET_VISUALIZER_MODE: 'SET_VISUALIZER_MODE',
  SET_NO_RESULTS: 'SET_NO_RESULTS',
  SET_HIGHER_THRESHOLD_RESULTS: 'SET_HIGHER_THRESHOLD_RESULTS',
  SET_LOWER_THRESHOLD_RESULTS: 'SET_LOWER_THRESHOLD_RESULTS',
  SET_EXTERNAL_TALMUD_RESULTS: 'SET_EXTERNAL_TALMUD_RESULTS',
  SET_EXTERNAL_TANAKH_RESULTS: 'SET_EXTERNAL_TANAKH_RESULTS',
  FOOTNOTES_NOT_RUN: 'FOOTNOTES_NOT_RUN',
  FOOTNOTES_COMPLETE: 'FOOTNOTES_COMPLETE',
  FOOTNOTES_RUNNING: 'FOOTNOTES_RUNNING',
  SERVER_FAILED: 'SERVER_FAILED',
  SERVER_TIMED_OUT: 'SERVER_TIMED_OUT',
  SYNOPSIS_RUNNING: 'SYNOPSIS_RUNNING',
  SYNOPSIS_COMPLETE: 'SYNOPSIS_COMPLETE',
  SYNOPSIS_SERVER_FAILED: 'SYNOPSIS_SERVER_FAILED',
  SYNOPSIS_SERVER_TIMED_OUT: 'SYNOPSIS_SERVER_TIMED_OUT',
  SET_SERVER_ERROR_MESSAGE: 'SET_SERVER_ERROR_MESSAGE'
}

export const Actions = {
  RUN_FOOTNOTES: 'RUN_FOOTNOTES',
  RUN_VISUALIZER: 'RUN_VISUALIZER',
  RUN_CHAPTERS: 'RUN_CHAPTERS',
  RUN_PARSE: 'RUN_PARSE',
  RUN_TANAKH_SEARCH: 'RUN_TANAKH_SEARCH',
  RUN_TALMUD_SEARCH: 'RUN_TALMUD_SEARCH',
  RUN_SYNOPSIS: 'RUN_SYNOPSIS'
}